import cn from 'classnames'

import { useReadFreePromotion } from '@hooks/chapter/useReadFreePromotion'
import { PromotionReadFreeEnum } from '@interfaces/PromotionTypeEnum'
import { ReadFreeProps } from './interface'
import { useInterval } from '@hooks/common/useInterval'
import { useMemo } from 'react'

export function ReadFree({
  className,
  chapterId,
  price,
  isPaid,
  isRestricted,
  bookReadPromotionDetail,
}: ReadFreeProps) {
  const { currentReadPromotion } = bookReadPromotionDetail
  const { readPromotionType } = currentReadPromotion
  const {
    isReadFreePromotion,
    showReadFreePerDay,
    showReadFreeWithInDay,
    showReadFreeInterval,
  } = useReadFreePromotion(bookReadPromotionDetail)
  const { tick } = useInterval()

  const ReadFreePerDay = useMemo(() => {
    if (readPromotionType === PromotionReadFreeEnum.READ_FREE_PER_DAY) {
      return showReadFreePerDay(chapterId)
    }
    return null
  }, [readPromotionType, chapterId, tick])

  const ReadFreeWithInDay = useMemo(() => {
    if (readPromotionType === PromotionReadFreeEnum.READ_FREE_WITHIN_DAY) {
      return showReadFreeWithInDay(chapterId)
    }
    return null
  }, [readPromotionType, chapterId, tick])

  if (!price || isPaid || isRestricted || !isReadFreePromotion(chapterId))
    return <div />

  return (
    <div
      className={cn(
        'flex flex-col text-[14px] font-light text-primary',
        className
      )}
    >
      {ReadFreePerDay}
      {ReadFreeWithInDay}
      {readPromotionType === PromotionReadFreeEnum.READ_FREE_INTERVAL &&
        showReadFreeInterval()}
    </div>
  )
}
